import { render, staticRenderFns } from "./salesman.vue?vue&type=template&id=afc2d776&"
import script from "./salesman.vue?vue&type=script&lang=js&"
export * from "./salesman.vue?vue&type=script&lang=js&"
import style0 from "./salesman.vue?vue&type=style&index=0&id=afc2d776&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afc2d776')) {
      api.createRecord('afc2d776', component.options)
    } else {
      api.reload('afc2d776', component.options)
    }
    module.hot.accept("./salesman.vue?vue&type=template&id=afc2d776&", function () {
      api.rerender('afc2d776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/SalesPromotion/salesman.vue"
export default component.exports